export default __webpack_public_path__ + "static/logo-service-thumbnail-4c4847f3a26a0a5084269d7d09e2bccd.jpg";